import { INPUT_TYPES } from "constants/form-builder";

export function formatSurveyResponse(formSchema, userResponse) {
  let formattedResponse = {};

  let stepCount = 0;
  let fieldCount = 0;

  formSchema.steps.forEach((step, stepIndex) => {
    step.fields.forEach((field, fieldIndex) => {
      let userAnswer = userResponse[field.id];
      if (userResponse.hasOwnProperty(field.id)) {
        //if question is picture select also grab selected picture
        const meta = {};
        if (field.type === INPUT_TYPES.ICONRADIO) {
          const userAnswer = userResponse[field.id];
          const selectedOption = (field.options || []).find(
            (option) => option.label === userAnswer
          );
          meta.selectedPicture = selectedOption?.image;
        }

        if (field.type === INPUT_TYPES.CHECKBOX) {
          userAnswer = userAnswer
            ? field?.checkedValue ?? true
            : field?.uncheckedValue ?? false;
        }

        if ([INPUT_TYPES.MULTICHIP].includes(field.type)) {
          userAnswer = userAnswer || [];
          //map each option to user answer
          field.options.forEach((option) => {
            const isOptionSelected = userAnswer.includes(option.label);
            formattedResponse[option.crmKey] = {
              crmKey: option.crmKey,
              question: field.label,
              step: step.title,
              stepId: step.id,
              stepIndex: stepIndex,
              fieldIndex: fieldIndex,
              answer: isOptionSelected
                ? option.selectedValue
                : option.unselectedValue,
              type: field.type,
              meta: {
                userAnswer,
                option,
              },
            };
          });
        } else if (field.type === INPUT_TYPES.CHECKBOXGROUP) {
          userAnswer = userAnswer || {};
          field.options.forEach((option) => {
            //check if checkbox was checked
            const isChecked = userAnswer[option.label];
            formattedResponse[option.crmKey] = {
              crmKey: option.crmKey,
              question: field.label,
              step: step.title,
              stepId: step.id,
              stepIndex: stepIndex,
              fieldIndex: fieldIndex,
              answer: isChecked ? option.selectedValue : option.unselectedValue,
              type: field.type,
              meta: {
                userAnswer,
                option,
              },
            };
          });
        } else {
          formattedResponse[field.id] = {
            crmKey: field.crmKey,
            question: field.label,
            step: step.title,
            stepId: step.id,
            stepIndex: stepIndex,
            fieldIndex: fieldIndex,
            answer: userAnswer,
            type: field.type,
            meta,
          };
        }

        fieldCount++;
      }
    });
    stepCount++;
  });

  return {
    formattedResponse,
    stepCount,
    fieldCount,
  };
}
